const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class DevelopmentOfTradeRoutes extends Event {
    constructor(){
        super(
            Age.AgeA,
            EventNames.DevelopmentOfTradeRoutes,
            "Each civilization scores 1 science and gains 1 resource and 1 food.",
            {}
        )
    }
}

module.exports = DevelopmentOfTradeRoutes;